import {Helper} from 'app/modules/core'
import {Field} from 'formik'
import styled from 'styled-components'

const TextUnderLine = styled(Field)`
  background: transparent;
  border: none;
  border-bottom: 1px solid #000000;
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
`

export const FormCheckBoxOther: React.FC<{
  key?: any
  field: {
    name: string
    value: any
    onChange?: (val: React.ChangeEvent<HTMLInputElement>) => void
  }
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  onCheckedChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  defaultChecked?: boolean
  checked?: boolean
  label?: string
  disabled?: boolean
  underlinName: string
}> = (props) => {
  //const dfVal: boolean = Helper.stringToBoolean(props.field.value)

  return (
    <>
      <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
        <input
          key={props.key}
          className='form-check-input'
          type='checkbox'
          name={props.field.name}
          disabled={props.disabled}
          checked={props.checked}
          defaultChecked={props.defaultChecked}
          onChange={(val) => {
            val && props.onCheckedChange?.(val)
            val && props.form.setFieldValue(props.field.name, val.target.checked ? true : false)
          }}
        />
        <span className='form-check-label text-dark fs-6'>{props.label}</span>
        <span className='form-check-label text-dark fs-6'>
          <TextUnderLine className='' name={props.underlinName} />
        </span>
      </label>
    </>
  )
}
